import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function RejectIcon(props: SvgIconProps) {
	return (
		<SvgIcon
			{...props}
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="6.06012"
				cy="6.00006"
				r="5.94"
				fill="#E87575"
				fill-opacity="0.4"
			/>
			<path
				d="M9.03033 3.76975L8.29061 3.03003L6.06099 5.26096L3.83005 3.03003L3.09033 3.76975L5.32126 6.00068L3.09033 8.23031L3.83005 8.97003L6.06099 6.7391L8.29061 8.97003L9.03033 8.23031L6.7994 6.00068L9.03033 3.76975Z"
				fill="#D85E5E"
			/>
		</SvgIcon>
	);
}
